import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./CumulativeDonationsSkeleton.module.scss";
export const CumulativeDonationsSkeleton: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.container}><div className={styles.graph} /><style>{"\n          \n        "}</style></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};